import { useQuery } from "@tanstack/react-query";

import { getFarmLivestock } from "services";

import { GET_FARM_LIVESTOCK } from "consts";

import { FarmLivestockEntry } from "models";

export const useGetFarmLivestock = ({ farmId, year }: { farmId?: string; year?: number }) =>
  useQuery<FarmLivestockEntry[]>({
    queryKey: [GET_FARM_LIVESTOCK, farmId, year],
    queryFn: () => getFarmLivestock({ farmId: farmId!, year: year! }),
    enabled: !!farmId && !!year,
  });
